import { Copy, FileCheck2, UploadCloud } from "lucide-react";
import { toast } from "sonner";
import { rupiah } from "@/lib/api";
import { SectionTitle } from "@/components/order/AthleteFields";

export default function PaymentBox({ settings, total, count, proof, setProof }) {
  const copy = (t) => navigator.clipboard?.writeText(t).then(() => toast.success("Nomor rekening disalin"));
  const pick = (e) => {
    const f = e.target.files?.[0];
    if (f && f.size > 10 * 1024 * 1024) return toast.error("Ukuran file maksimal 10MB");
    setProof(f || null);
  };
  return (
    <section>
      <SectionTitle n="3">Pembayaran & Bukti Transfer</SectionTitle>
      <div className="grid md:grid-cols-2 gap-4">
        <div className="border border-[#FF5A00] bg-[#FF5A00]/10 p-6 shadow-[0_0_30px_rgba(255,90,0,0.15)]">
          <p className="font-display uppercase font-bold text-neutral-300">Total Bayar ({count} mata lomba)</p>
          <p data-testid="order-total" className="font-display font-black text-5xl mt-2">{rupiah(total)}</p>
          <div className="mt-6 space-y-3">
            {(settings?.bank_accounts || []).map((b, i) => (
              <div key={i} data-testid={`bank-account-${i}`} className="bg-black/40 border border-white/10 p-3 flex items-center justify-between gap-3">
                <div>
                  <p className="text-xs text-neutral-400 uppercase">{b.bank}</p>
                  <p className="font-display font-extrabold text-2xl tracking-wide">{b.number}</p>
                  <p className="text-sm text-neutral-300">a.n. {b.holder}</p>
                </div>
                <button type="button" onClick={() => copy(b.number)} data-testid={`copy-bank-${i}`} className="p-2 hover:text-[#FF5A00] transition-colors"><Copy className="w-4 h-4" /></button>
              </div>
            ))}
            {settings?.qris_note && <p className="text-sm text-neutral-300">{settings.qris_note}</p>}
          </div>
        </div>
        <label data-testid="proof-dropzone" className="border-2 border-dashed border-white/20 hover:border-[#FF5A00] transition-colors bg-[#121212] p-6 flex flex-col items-center justify-center text-center cursor-pointer min-h-[220px]">
          <input type="file" accept="image/jpeg,image/png,image/webp,application/pdf" className="hidden" onChange={pick} data-testid="proof-file-input" />
          {proof ? <FileCheck2 className="w-10 h-10 text-emerald-400" /> : <UploadCloud className="w-10 h-10 text-[#FF5A00]" />}
          <p className="font-display uppercase font-bold text-xl mt-3">{proof ? "Bukti terpilih" : "Upload Bukti Transfer"}</p>
          <p className="text-sm text-neutral-400 mt-1 break-all" data-testid="proof-file-name">{proof ? proof.name : "JPG, PNG, WEBP atau PDF · maks 10MB"}</p>
          {proof?.type?.startsWith("image/") && <img src={URL.createObjectURL(proof)} alt="preview" className="mt-4 max-h-40 object-contain" />}
        </label>
      </div>
    </section>
  );
}
